export default __webpack_public_path__ + "static/media/certification9.ae87741c.jpg";